import axios from 'axios';
// import store from '@/store'
import { Toast } from 'vant'
import baseURL from './setBaseUrl'
// import { getToken } from './auth';
var i = 0;
var axiosLength = 0;
const service = axios.create({
  baseURL: baseURL,
  timeout: 3000000,
  headers: {
    // "Access-Control-Allow-Origin": "*",
  }
});

service.interceptors.request.use(
  (config) => {
    config.headers['id'] = 1
    axiosLength = config.adapter.length
    return config;
  },
  (error) => {
    // console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    i++
    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      if (i === axiosLength) {
        // Toast(res.msg || '请求失败请联系管理员')
      }
      return res;
    }
  },
  (error) => {
    i++
    if (i === axiosLength) {
      Toast(error.msg || '请求失败请联系管理员')
    }
    return Promise.reject(error);
  }
);

export default service;
